"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const ViewZero_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ViewZero.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
let MapSideBarPanelProducts = class MapSideBarPanelProducts extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentProduct = null;
        this.searchParameter = '';
        this.productsFilter = [];
        this.hasPorfolioPanel = false;
    }
    get products() {
        return this.areaProjectMapController.products.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }
    capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    dismissPorfolioPanel() {
        this.currentProduct = null;
        this.hasPorfolioPanel = false;
    }
    setCurrentProduct(newProduct) {
        if (this.currentProduct && this.currentProduct.id === newProduct.id) {
            this.currentProduct = null;
            this.hasPorfolioPanel = false;
        }
        else {
            this.currentProduct = newProduct;
            this.hasPorfolioPanel = true;
        }
    }
    onSearchChange(searchParameter) {
        this.searchParameter = searchParameter;
        this.productsFilter = this.products.filter(product => {
            const search = searchParameter.trim().toLowerCase();
            const matchesName = product.name.trim().toLowerCase().includes(search);
            const matchesPortfolio = product.portfolio.some(item => item.name.trim().toLowerCase().includes(search));
            return matchesName || matchesPortfolio;
        });
        if (!searchParameter)
            this.productsFilter = [];
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBarPanelProducts.prototype, "areaProjectMapController", void 0);
MapSideBarPanelProducts = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Search: bmk_ui_framework_1.Search, WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon, Button: bmk_ui_framework_1.Button, Separator: bmk_ui_framework_1.Separator, Loading: bmk_ui_framework_1.Loading, MapSideBarPanel: MapSideBarPanel_vue_1.default, ViewZero: ViewZero_vue_1.default, FilterIcon: bmk_ui_framework_1.FilterIcon, X: lucide_vue_next_1.X, Info: lucide_vue_next_1.Info, Dropdown: floating_vue_1.Dropdown, Package: lucide_vue_next_1.Package }
    })
], MapSideBarPanelProducts);
exports.default = MapSideBarPanelProducts;
